import { Component } from '@angular/core';
import { ICellEditorAngularComp, ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SendNotification } from '../ag-grid.model';
import { AgGridService } from '../ag-grid.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonPopupComponent } from 'src/app/shared/common-popup/common-popup.component';
export interface Icons{
  cameraIcon:boolean,
  resetIcon:boolean,
  saveIcon:boolean,
  editIcon:boolean,
  focusOnColumn:string,
  tableId?:string,
  isEditRowOnEdit :boolean,
  isFirstDeleteIcon:boolean,
  isDeleteIcon:boolean,
  billIcon:boolean,
  printIcon:boolean,
  isCheckbox:boolean,
  isConfirmationPopOpen
 }
@Component({
  selector: 'app-email-icon-renderer',
  templateUrl: './email-icon-renderer.component.html',
  styleUrls: ['./email-icon-renderer.component.scss']
})

export class EmailIconRendererComponent implements ICellRendererAngularComp{
  public params: ICellRendererParams & Icons;
  sendNotifications = new SendNotification()

  constructor(   
    public agGridService: AgGridService,
    public toaster: ToastrService,
    private modalService : NgbModal,
    ){

  }

  agInit(params: ICellRendererParams & Icons): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }


  handlePrintClick(params): void {
    const customEvent = new CustomEvent('printButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(customEvent);
  }
  clickOnEmail(params){
    console.log(params);
    const selectedData = { data: [params?.data?.id], notificationTypeId: 1 };
    this.sendNotification(selectedData)
  }
  sendNotification(selectedData){
    if(this.params.data.email !== ''){
    this.sendNotifications.notificationTypeId = selectedData.notificationTypeId;
    this.sendNotifications.id  = selectedData.data;
    this.agGridService.sendNotification(this.sendNotifications).subscribe(res => {
      console.log(res);
      if (res.isSuccess) {
        this.toaster.success(res.message)
      }else{
        this.toaster.error(res.message)
  
      }
    })
  }else{
    this.toaster.error("Mail is empty.")
  }

  
  }

  openConfirmationPopup(params): void {
    const modalOption: NgbModalOptions = {
      centered: true,
      backdrop: "static",
      keyboard: false,
      size: "sm",
    };
      const modalRef = this.modalService.open(CommonPopupComponent, modalOption);
      modalRef.componentInstance.sendToMailOrWhatsapp = 'email';
      modalRef.result.then((res) => {
       if(res){
      this.clickOnEmail(params)
       }
      })
  }
  
}


